<template>
  <MainCard
    title="Captação de alunos"
    subtitle="Média geral da probabilidade atribuída aos registros na última atualização."
    :actionButton="{ label: 'Configurações', to: '/configuration/catchment', icon: 'mdi-cog-outline' }"
  >
  <v-sheet v-if="lastUpdates" class="aleta-nao-processado mt-2 mb-4">
    <p><strong><i>Atenção!</i></strong> Sua configuração ainda não foi processada. <strong>Essa ação pode demorar até 24h.</strong></p>
  </v-sheet>
  <rb-loader v-if="loading_status" v-model='reportAll' :contained="true" />
  <v-sheet v-else class="d-flex flex-column w-100 mb-8" :class="{ 'is-blurred': isBlurred }">
    <!--Overview-->
    <v-card class="d-flex w-100" elevation="0">
      <PerformanceOverview
        :data="reportAll"
      />
    </v-card>
    
    <!-- Converções por cidade -->
    <v-card class="d-flex w-100 pa-8" elevation="0">
      <ConversionsByCity
        :data="reportAll"
      />
    </v-card>

    <!-- Converções por curso -->
     <v-card class="d-flex w-100 pl-8 pr-8 pb-8" elevation="0">
      <ConversionByCourse
        :data="reportAll"
      />
     </v-card>

    <!-- Converções por etapa e processo -->
     <v-card class="d-flex w-100 pl-8 pr-8 pb-8" elevation="0">
      <ConversionByStepProcess
        :data="reportAll"
      />
     </v-card>

    <!-- Tempo conversao por oferta de curso  -->
     <v-card class="d-flex w-100 pl-8 pr-8 pb-8" elevation="0">
      <ConversionbyCourseOffer
        :data="reportTimeByCourse"
      />
     </v-card>

    <!-- Tempo conversao por etapa e curso  -->
     <v-card class="d-flex w-100 pl-8 pr-8 pb-8" elevation="0">
      <ConversionByStepCourse
        :data="reportTimeByStep"
      />
     </v-card>
  </v-sheet>

  </MainCard>

</template>

<script>
import MainCard from '@/ai_studio/components/layout/MainCard.vue';
import RbLoader from "@/ai_studio/components/common/RbLoader.vue";
import PerformanceOverview from '../components/PerformanceOverview.vue';
import ConversionsByCity from '../components/ConversionsByCity.vue';
import ConversionByCourse from '../components/ConversionByCourse.vue';
import ConversionByStepProcess from '../components/ConversionByStepProcess.vue';
import ConversionbyCourseOffer from '../components/ConversionbyCourseOffer.vue';
import ConversionByStepCourse from '../components/ConversionByStepCourse.vue';
import { Get, PostWithJson } from "@/ai_studio/http/http.js";

export default {
  name: "CatchmentView",

  components: {
    MainCard,
    RbLoader,
    PerformanceOverview,
    ConversionsByCity,
    ConversionByCourse,
    ConversionByStepProcess,
    ConversionbyCourseOffer,
    ConversionByStepCourse
  },
  data() {
    return {
      loading_status: true,
      reportAll: [],
      reportTimeByCourse: [],
      reportTimeByStep: [],
      lastUpdates: true,
    }
  },

  async mounted() {
    await this.fetchReports();
  },

  computed: {
    hasReportAll () {
      const v = this.reportAll;
      if (!v.success) return false
      if (Array.isArray(v?.dados)) return v.dados.length > 0;
      if (Array.isArray(v)) return v.length > 0;
      return v && typeof v === 'object' ? Object.keys(v).length > 0 : !!v;
    },
    hasReportTimeByCourse () {
      const v = this.reportTimeByCourse;
      return Array.isArray(v) ? v.length > 0 : Array.isArray(v?.dados) ? v.dados.length > 0 : false;
    },
    hasReportTimeByStep () {
      const v = this.reportTimeByStep;
      return Array.isArray(v) ? v.length > 0 : Array.isArray(v?.dados) ? v.dados.length > 0 : false;
    },
    shouldLockScroll () {
      return !this.loading_status && !this.hasReportAll && !this.hasReportTimeByCourse && !this.hasReportTimeByStep;
    },

    isBlurred () {
      return !this.hasReportAll
    },
  },

  methods: {
    async fetchReports() {
      try {
        this.loading_status = true;
        const [reportAll, reportTimeByCourse, reportTimeByStep, configs] = await Promise.all([
          PostWithJson("insights/getReport"),
          PostWithJson("insights/getReportTimeByCourse"),
          PostWithJson("insights/getReportTimeByStep"),
          Get("insights/getConfigByClient"),
        ]);
        if (!reportAll.success) {
          this.reportAll = [];
          this.reportTimeByCourse = [];
          this.reportTimeByStep = [];
        }

        this.reportAll = reportAll
        if(this.reportAll) {
          this.reportTimeByCourse = Array.isArray(reportTimeByCourse?.dados) ? reportTimeByCourse.dados : (Array.isArray(reportTimeByCourse) ? reportTimeByCourse : []);
          this.reportTimeByStep = Array.isArray(reportTimeByStep?.dados) ? reportTimeByStep.dados : (Array.isArray(reportTimeByStep) ? reportTimeByStep : []);
        }
        const lastExecArray = Array.isArray(configs?.lastDataExec)
            ? configs.lastDataExec
            : Array.isArray(configs?.dadosLastExec)
              ? configs.dadosLastExec
              : [];
        this.lastUpdates = lastExecArray.length === 0;
      } catch (e) {
        console.error(e);
        this.$toast?.error?.("Não foi possível carregar os relatórios. Tente novamente.");
        this.reportAll = [];
        this.reportTimeByCourse = [];
        this.reportTimeByStep = [];
      } finally {
        this.loading_status = false;
      }
    },
  },

  watch: {
    shouldLockScroll: {
      immediate: true,
      handler (lock) {
        const els = [
          document.documentElement,
          document.body,
          document.querySelector('#app'),
          document.querySelector('.v-application')
        ].filter(Boolean);

        this.$nextTick(() => {
          els.forEach(el => {
            if (lock) {
              el.style.overflowY = 'hidden';
              el.style.height = '100vh';
            } else {
              el.style.overflowY = 'auto';
              el.style.overflowX = '';
              el.style.height = '';
            }
          });
        });
      }
    }
  },

  beforeUnmount () {
    [document.documentElement, document.body, document.querySelector('#app'), document.querySelector('.v-application')]
      .filter(Boolean)
      .forEach(el => {
        el.style.overflowY = '';
        el.style.overflowX = '';
        el.style.height = '';
      });
  }

}
</script>

<style>
  .is-blurred {
  filter: blur(3px);
  opacity: 0.6;
  pointer-events: none;
  user-select: none;
  transition: filter .2s ease, opacity .2s ease;
}
</style>